import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import LaunchIcon from '@material-ui/icons/Launch'
import { withStyles } from '@material-ui/core/styles'
const styles = theme => ({
  button: {
    margin: 10
  }
})
class TicketPrintForm extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    hiboutikAccount: PropTypes.string.isRequired,
    saleId: PropTypes.string.isRequired
  }

  state = {
    iframe: true
  }

  handleSubmitClick = e => {
    this.setState({ iframe: true })
    this.refs.show_form.submit()
  }
  handleLoaded = e => {
    this.setState({ iframe: false })
  }
  render() {
    const { className, classes, saleId, hiboutikAccount } = this.props
    return (
      <div>
        <Button
          color="primary"
          className={className || classes.button}
          variant="raised"
          onClick={this.handleSubmitClick}>
          <LaunchIcon color="inherit" />
        </Button>
        <form
          ref="show_form"
          method="post"
          action={`https://${hiboutikAccount}.hiboutik.com/`}
          target="_blank">
          <input type="hidden" name="ma_commande_affiche" value={saleId} />
        </form>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    hiboutikAccount: state.auth.hiboutikAccount
  }
}

export default connect(mapStateToProps, {})(withStyles(styles)(TicketPrintForm))



// WEBPACK FOOTER //
// ./src/components/hiboutikForms/ShowSaleForm.js